<template>
  <v-form v-model="valid" ref="form" lazy-validation>
    <v-list subheader three-line>
      <v-subheader>Booking Limitation</v-subheader>

      <v-layout>
        <v-flex md6>
          <v-list-tile>
            <v-list-tile-action>
              <v-text-field
                v-model="seatLimit"
                label="Reservation per schedule"
                suffix="seat"
                mask="####"
                required
                outline
                :rules="[rules.required, rules.number]"
              ></v-text-field>
            </v-list-tile-action>
          </v-list-tile>
        </v-flex>

        <v-flex md3>
          <v-list-tile>
            <v-list-tile-action>
              <v-menu
                ref="timeFromMenu"
                :close-on-content-click="false"
                v-model="timeFromMenu"
                :nudge-right="40"
                lazy
                transition="scale-transition"
                offset-y
                full-width
                min-width="290px"
              >
                <v-text-field
                  slot="activator"
                  v-model="timeFrom"
                  label="Schedule Time From"
                  prepend-inner-icon="schedule"
                  @click="clockMode = 'timeFrom'"
                  readonly
                  outline
                ></v-text-field>

                <v-time-picker v-model="timeFrom" format="24hr">
                  <v-btn flat color="amber" @click="cancelTimePicker"
                    >Reset
                  </v-btn>
                  <v-spacer></v-spacer>
                  <v-btn flat color="amber" @click="timeFromMenu = false"
                    >DONE</v-btn
                  >
                </v-time-picker>
              </v-menu>
            </v-list-tile-action>
          </v-list-tile>
        </v-flex>
        <v-flex md3>
          <v-list-tile>
            <v-list-tile-action>
              <v-menu
                ref="timeToMenu"
                :close-on-content-click="false"
                v-model="timeToMenu"
                :nudge-right="40"
                lazy
                transition="scale-transition"
                offset-y
                full-width
                min-width="290px"
              >
                <v-text-field
                  slot="activator"
                  v-model="timeTo"
                  label="Schedule Time To"
                  prepend-inner-icon="schedule"
                  @click="clockMode = 'timeTo'"
                  readonly
                  outline
                ></v-text-field>

                <v-time-picker v-model="timeTo" format="24hr">
                  <v-btn flat color="amber" @click="cancelTimePicker"
                    >Reset
                  </v-btn>
                  <v-spacer></v-spacer>
                  <v-btn flat color="amber" @click="timeToMenu = false"
                    >DONE</v-btn
                  >
                </v-time-picker>
              </v-menu>
            </v-list-tile-action>
          </v-list-tile>
        </v-flex>
      </v-layout>
    </v-list>

    <!-- <v-divider></v-divider> -->
  </v-form>
</template>

<script>
export default {
  props: {
    data: Object,
    subcompanies: Array,
  },
  computed: {
    computedData() {
      return {
        id: this.data.id,
        schedule_seat_limit: this.seatLimit,
        schedule_time_from: `${this.timeFrom ? this.timeFrom : "00:00"}:00`,
        schedule_time_to: `${this.timeTo ? this.timeTo : "23:59"}:59`,
      };
    },
    tripmanifest() {
      if (
        this.data.trip_manifest_status === 1 ||
        this.data.trip_manifest_status === true
      ) {
        return true;
      } else {
        return false;
      }
    },
    dispatcherStatus: {
      get() {
        return this.data.dispatcher_status;
      },
      set(value) {
        this.data.dispatcher_status = value;

        this.data.teller_status = 0;
      },
    },
    tellerStatus: {
      get() {
        return this.data.teller_status;
      },
      set(value) {
        this.data.teller_status = value;

        this.data.dispatcher_status = 0;
        this.data.conductor_status = 0;
      },
    },
  },
  data() {
    return {
      valid: true,
      rules: {
        required: (value) => !!value || "This field is required.",
        counter: (value) => value.length <= 20 || "Max 20 characters",
        number: (value) => !isNaN(value) || "Must be number.",
        minFloor: (value) => value >= 1 || "The minimum number is 1.",
        maxFloor: (value) => value <= 30 || "The maximum number is 30.",
        // minRow: value => value >= 10 || "The minimum row is 10",
        // maxRow: value => value <= 15 || "The maximum row is 15.",
        // minColumn: value => value >= 4 || "The minimum row is 4.",
        // maxColumn: value => value <= 7 || "The maximum row is 7."
      },

      clockMode: "",
      timeFromMenu: false,
      timeToMenu: false,
      seatLimit: this.data.schedule_seat_limit
        ? this.data.schedule_seat_limit
        : "0",
      timeFrom: this.data.schedule_time_from
        ? this.$dateFormat(
            "2020-01-01 " + this.data.schedule_time_from,
            "HH:mm"
          )
        : "00:00",
      timeTo: this.data.schedule_time_to
        ? this.$dateFormat("2020-01-01 " + this.data.schedule_time_to, "HH:mm")
        : "23:59",
    };
  },
  methods: {
    clear() {
      this.$refs.form.reset();
    },
    validateForm() {
      return this.$refs.form.validate();
    },
    cancelTimePicker() {
      if (this.clockMode === "timeFrom") {
        this.timeFrom = "00:00";
        this.timeFromMenu = false;
      }
      if (this.clockMode === "timeTo") {
        this.timeTo = "23:59";
        this.timeToMenu = false;
      }
    },
  },
};
</script>

<style scoped>
.scrolling-wrapper {
  overflow-x: hidden;
  height: 200px;
  overflow-y: scroll;
  white-space: nowrap;
}
</style>